module.exports = __webpack_public_path__ + "static/media/logo-k.b0721d67.svg";